module.exports = __webpack_public_path__ + "media/images/lp_cv-block-3-sp-c4b91c6888da6acdb8a06f5396c33af6.webp";